<template>
  <div
    :class="[
      'header',
      aplaHeaderBg == 1 ? 'header-shadow' : '',
      index !== 0 ? 'header-shadow' : '',
      isShowLiveSet ? 'no_filter' : '',
    ]"
    @click="toAdBg(homeBg)"
  >
    <div class="wraper" @click.stop="emptyFunc">
      <div class="header-left">
        <router-link @click.native="btnClick(0)" class="main_logo" to="/">
          <div class="logo" :class="icos[site]"></div>
        </router-link>
        <div class="headLink">
          <router-link
            @click.native="btnClick(0)"
            to="/home"
            :class="index == 0 && isHomePage ? 'active-select' : ''"
            >{{ $t("pc.home") }}</router-link
          >
          <router-link
            @click.native="btnClick(1)"
            to="/liveMatches"
            :class="index === 1 ? 'active-select' : ''"
            >{{ $t("common.live") }}</router-link
          >
          <!-- <router-link
            @click.native="btnClick(2)"
            to="/schedule"
            :class="index === 2 ? 'active-select' : ''"
            >{{ $t("pc.liveScore") }}</router-link
          > -->
          <!-- <router-link
            v-if="appConfig.worldcup_thematic_toggle == 1"
            @click.native="btnClick(7)"
            to="/worldCup"
            :style="
              isHomePage
                ? { color: aplaHeaderBg == 1 ? '#333333' : '#ffffff' }
                : ''
            "
            :class="index === 7 ? 'wc_nav_select' : ''"
            >世界杯</router-link
          > -->
          <!-- <router-link @click.native="btnClick(3)" to="/news" :style="isHomePage ? { color: aplaHeaderBg == 1 ? '#333333' : '#ffffff' } : ''" :class="index === 3 ? 'active-select' : ''"
            >资讯</router-link
          > -->
          <!-- <router-link @click.native="btnClick(4)" to="/activity" :style="isHomePage ? { color: aplaHeaderBg == 1 ? '#333333' : '#ffffff' } : ''" :class="index === 4 ? 'active-select' : ''"
            >活动</router-link
          >
          <router-link @click.native="btnClick(5)" to="/mall" :style="isHomePage ? { color: aplaHeaderBg == 1 ? '#333333' : '#ffffff' } : ''" :class="index === 5 ? 'active-select' : ''">
            猎鹰商城
          </router-link> -->
          <!-- <div :style="index == 0 ? 'color: #fff' : ''" :class="['active', index == 6 ? 'active-select' : '']" @click="btnClick(6)">游戏</div> -->
        </div>
      </div>

      <div class="header-right">
        <div class="controller">
          <div
            v-if="isAnchor"
            class="start-btn"
            @click.stop="startLive()"
            @mouseover="liveActive = true"
            @mouseout="liveActive = false"
          >
            <span class="icon"
              ><img
                :src="
                  require(liveActive
                    ? '@/assets/home/live_active.png'
                    : '@/assets/home/live.png')
                "
            /></span>
            <p>{{ isLiving ? $t("chat.living") : $t("pc.startLive") }}</p>
          </div>
          <div
            class="un-login-btn flex-column flex-middle"
            :class="{ block: block && isHomePage }"
            v-if="!userInfo.id"
            @click.stop
            @mouseover="block = false"
          >
            <img
              class="img-login"
              :src="
                isHomePage
                  ? require('./top_sign_in_white.png')
                  : require('./mine_nav_ziliao_nor.png')
              "
            />
            <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>

            <div class="un-login-content">
              <div class="login-content">
                <!-- <div class="line"></div>
                <div class="line2"></div> -->
                <!--未登陆-->
                <div style="padding: 0.3rem 0.3rem 0.16rem">
                  <div class="un-login-title">
                    <img :src="require('@/assets/home/left.png')" alt="" />
                    <span>{{ $t("home.afterLogin") }}</span>
                    <img :src="require('@/assets/home/right.png')" alt="" />
                  </div>
                  <el-row style="margin-top: 0.16rem">
                    <el-col
                      :span="12"
                      class="flex-column flex-middle-only"
                      style="margin-bottom: 0.15rem"
                    >
                      <img
                        class="icon-img"
                        :src="require('@/assets/home/1.png')"
                        alt=""
                      />
                      <span class="icon-text">{{ $t("home.info1") }}</span>
                    </el-col>
                    <el-col
                      :span="12"
                      class="flex-column flex-middle-only"
                      style="margin-bottom: 0.15rem"
                    >
                      <img
                        class="icon-img"
                        :src="require('@/assets/home/2.png')"
                        alt=""
                      />
                      <span class="icon-text">{{ $t("home.info2") }}</span>
                    </el-col>
                    <el-col :span="12" class="flex-column flex-middle-only">
                      <img
                        class="icon-img"
                        :src="require('@/assets/home/3.png')"
                        alt=""
                      />
                      <span class="icon-text">{{ $t("home.info3") }}</span>
                    </el-col>
                    <el-col :span="12" class="flex-column flex-middle-only">
                      <img
                        class="icon-img"
                        :src="require('@/assets/home/4.png')"
                        alt=""
                      />
                      <span class="icon-text">{{ $t("home.info4") }}</span>
                    </el-col>
                  </el-row>

                  <el-button class="login-now" @click="toggleLogin">{{
                    $t("pcLive.loginNow")
                  }}</el-button>
                  <div class="flex-middle" @click="toggleRegister">
                    {{ $t("home.firstUse") }}
                    <span
                      style="
                        color: rgba(208, 45, 84, 1);
                        margin-left: 0.04rem;
                        cursor: pointer;
                      "
                      >{{ $t("home.touchToRegister") }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="login2">
            <router-link to="/user-center/index">
              <img :src="userInfo.avatar || defaultAvatar" class="avatar" />
              <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>
            </router-link>

            <div class="un-login-content" :style="{ height: '3.04rem' }">
              <div class="login-content">
                <!--已登陆-->
                <UserCard
                  :isLiving="isLiving"
                  :userInfo="userInfo"
                  @startLive="startLive"
                />
              </div>
            </div>
          </div>
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            style="width: 100px; padding-left: 10px"
          >
            <span class="el-dropdown-link">
              {{ langData[this.$i18n.locale]
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
              <el-dropdown-item command="en-US">English</el-dropdown-item>
              <el-dropdown-item command="vi-VN">Tiếng Việt</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- <RechargeDialog></RechargeDialog> -->
    <div @click.stop="emptyFunc()">
      <start-live-set
        v-if="isShowLiveSet"
        :isShow.sync="isShowLiveSet"
        @closeDialog="closeDialog"
      >
      </start-live-set>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
// import getPlatform from "../../util/platform";
import { post } from "@/util/http";
import UserCard from "@/components/user-card/user-card.vue";
import StartLiveSet from "@/components/start-live-set/start-live-set";
import QrCard from "@/components/qr-card/qr-card";
import event from "@/event";
import { onMounted } from "vue";
// import RechargeDialog from "@/components/dialog/RechargeDialog";
export default {
  components: {
    StartLiveSet,
    QrCard,
    UserCard,
    // RechargeDialog,
  },

  inject: ["reload"],
  data() {
    return {
      aplaHeaderBg: 0.03,
      // isHomePage: localStorage.getItem("isHomePage") == "true" ? require("./logo.png") : require("./logo4x.png"),
      showQr: false,
      timeOutUserCard: "",
      timeOutQrCard: "",
      showSubNav: false,
      active: "",
      searchKey: "",
      limitPosition: 400,
      isShowLiveSet: false,
      gameUrl: "",
      routers: [
        "/home",
        "/liveMatches",
        "/schedule",
        "/news",
        "/activity",
        "/game",
        "/app-download",
        "/worldCup",
      ],
      index: 0,
      hoveract: null,
      hovertitle: null,
      pathname: "",
      homeBg: {},
      block: true,
      langData: {
        "zh-CN": "中文",
        "en-US": "English",
        "vi-VN": "Tiếng Việt",
      },
      liveActive: false,
      isAnchor: false, //是否主播
      site: SITE,
      icos: {
        onv2: "",
        "8on": "logo_8on",
        sport247: "logo_sport247",
      },
    };
  },

  watch: {
    $route(to, from) {
      console.log("$route to==>", to.path);
      this.pathname = to.path;
      this.getHomeBanner();
      console.log("$route from==>", from.path);
    },
    isHomePage(flag) {
      if (flag) this.block = true;
    },
  },

  computed: {
    ...mapState([
      "userInfo",
      "defaultAvatar",
      "categories",
      "pageConfig",
      "isHomePage",
      "appConfig",
    ]),
    ...mapGetters(["isLiving", "unreadTotal"]),
  },

  created() {
    this.getHomeBanner();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll");
  },

  async mounted() {
    this.routerDetect(window.location.pathname);
    if (localStorage.getItem("userInfo")) {
      //this.$store.dispatch("getUserInfo")
      this.changeUserInfo(JSON.parse(localStorage.getItem("userInfo")));
      this.getUserInfo();
      this.$store.dispatch("checkAnchorStatus");
    }
    this.index = this.routers.indexOf(window.location.pathname);

    event.$on("start-live", (flag) => {
      console.log("start-live", flag);
      this.isShowLiveSet = flag;
    });

    if (this.userInfo && this.userInfo.id) {
      post({
        url: "/api/user/checkAnchorStatus",
      })
        .then(({ data: { data } }) => {
          console.log(data, "datadatadatadatadata");
          let { is_anchor = 0, is_live = 0 } = data;
          if (!!is_anchor) {
            this.isAnchor = true;
          }
        })
        .catch((err) => console.log("err: ", err));
    }
  },

  methods: {
    ...mapMutations([
      "toggleLogin",
      "toggleRegister",
      "changeLoginType",
      "toggleDynamicRel",
      "changeUserInfo",
      "changeNavCategoryName",
      "toggleCheckinDialog",
    ]),
    toCheckin() {
      // this.toggleCheckinDialog(true);
    },
    toLottery() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.$router.push("/lottery");
    },
    toAdBg({ jump_url = "", jump_type = 2 }) {
      if (this.isHomePage) {
        return;
      }
      let url = jump_url || "";
      let v =
        /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/gim;
      if (v.exec(url) && jump_type == 2) {
        window.open(url);
      } else if (url && jump_type == 1) {
        this.$router.push(url);
      }
    },
    handleScroll() {
      let top = window.pageYOffset;
      // console.log("top； ",top);
      let apla = 0.03;
      if (top >= 0 && top <= 300) {
        apla = 0.03;
      } else if (top > 300 && top < 400) {
        apla = top * 0.0002;
      } else {
        apla = 1;
      }
      this.aplaHeaderBg = apla;
    },
    async getHomeBanner() {
      const {
        data: { data },
      } = await post({
        url: "/api/ads/getAds",
        data: {
          equipment: 1,
          category: this.pathname == "/home" ? 6 : 11,
        },
      });
      if (data) {
        this.homeBg = data[0] || {};
        // console.log(this.homeBg)
      }
    },
    routerDetect(path) {
      if (path.indexOf("home") > 0) {
        this.index = 0;
      }
      if (path.indexOf("liveMatches") > 0) {
        this.index = 1;
      }
      //选中达人榜
      if (path.indexOf("ranking") > 0) {
        this.hoveract = 0;
      }
      //选中下载
      if (path.indexOf("download") > 0) {
        this.hoveract = 1;
      }
      //选中关注
      if (path.indexOf("user-center/focus") > 0) {
        this.hoveract = 2;
      }
      //选中开播
      if (path.indexOf("apply-anchor") > 0) {
        this.hoveract = 3;
      }
    },
    goSearch() {
      if (this.searchKey.length > 10) {
        this.$message({
          showClose: true,
          message: "搜索内容最多10个字",
          type: "warning",
        });
        return;
      }
      // this.changeSearchKey(this.searchKey);
      this.$router.push({
        path: "/keysearch",
        query: {
          keyword: this.searchKey,
        },
      });
      this.searchKey = "";
      return;
    },

    startLive() {
      if (this.userInfo && this.userInfo.id) {
        post({
          url: "/api/user/checkAnchorStatus",
        })
          .then(({ data: { data } }) => {
            let { is_anchor = 0, is_live = 0 } = data;
            if (is_anchor == 0) {
              this.$router.push("/user-center/apply-anchor");
              return;
            }
            if (is_live == 1) {
              if (
                window.location.href.indexOf(
                  `liveMatchesTwo/${this.userInfo.id}`
                ) > 0
              ) {
                this.reload();
                return;
              }
              this.$router.push(`/liveMatchesTwo/${this.userInfo.id}`);
              if (window.location.href.indexOf("liveMatchesTwo") > 0) {
                this.reload();
              }
            } else {
              this.isShowLiveSet = true;
            }
          })
          .catch((err) => console.log("err: ", err));
      }
    },
    toFocus() {
      // to="/user-center/focus"
      if (!localStorage.getItem("userInfo")) {
        this.toggleLogin();
        return;
      }
      this.$router.push("/user-center/focus");
    },
    toRanking() {
      this.$router.push("/ranking");
    },

    closeDialog() {
      this.isShowLiveSet = false;
    },

    // handleClose(done) {
    //   this.$confirm("确认关闭？")
    //     .then((_) => {
    //       done();
    //     })
    //     .catch((_) => {});
    // },

    async getUserInfo() {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let { mobile = "" } = data.data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          mobile: data.data.mobile,
          formatPhone: data.data.formatPhone,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        this.changeUserInfo({
          ...keyValue,
        });
      }
    },

    btnClick(tag) {
      // if (tag == 5) {
      //   if (!this.userInfo.id) {
      //     this.toggleLogin();
      //     return;
      //   } else {
      //     this.$router.push("/mall");
      //   }
      // }
      this.index = tag;

      // if (this.index == tag) {
      //   location.reload();
      //   return;
      // }
      // let path = this.routers[tag];
      // if (tag == 0) {
      //   this.$router.replace(path);
      // }
      // if (tag == 1 || tag == 2 || tag == 3 || tag == 4 || tag == 5 || tag == 6) {
      //   this.$router.push({
      //     path: path,
      //   });
      // }

      // if (tag == 7) {
      //   let routeUrl = this.$router.resolve({
      //     path: path,
      //   });
      //   window.open(routeUrl.href, "_blank");
      // }
    },

    // 头部右边hover
    showTxt(index) {
      this.hoveract = index;
    },

    showtitleFn(index) {
      this.hovertitle = index;
      console.log(this.hovertitle);
    },
    emptyFunc() {},
    handleCommand(command) {
      this.$i18n.locale = command;
      localStorage.setItem("lang", command);
      location.reload();
      // this.$message("click on item " + this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variable.scss";

.un-login-btn {
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.4rem;
  padding-left: 0.1rem;
  cursor: pointer;
  position: relative;

  &.block {
    .un-login-content {
      display: block !important;
    }
  }

  &:hover {
    .un-login-content {
      display: block;
    }
  }
}

.un-login-content {
  display: none;
  clear: both;
  width: 4rem;
  height: 3.58rem;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.05rem;
  border-radius: 0.1rem;
  position: absolute;
  z-index: 5;
  top: 0.42rem;
  right: -1.05rem;
  background-image: url("~@/assets/home/user_bg.png");
  background-size: 100% 100%;

  .login-content {
    display: block;
    clear: both;
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.25rem);
    overflow: hidden;
    box-sizing: border-box;
    /* background-image: url("~@/components/header/inset-bg.png"); */
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
    top: 0.1rem;
    left: 0.16rem;
    .line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 2rem;
      height: 1px;
      margin-top: -0.2rem;
      background: linear-gradient(
        90deg,
        rgba(219, 10, 7, 0) 0%,
        #f75a58 49.65%,
        rgba(219, 10, 7, 0) 100%
      );
    }
    .line2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      width: 1.5rem;
      height: 1px;
      background: linear-gradient(
        90deg,
        rgba(219, 10, 7, 0) 0%,
        #f75a58 49.65%,
        rgba(219, 10, 7, 0) 100%
      );
    }
  }

  .icon-text {
    font-size: 0.14rem;
    line-height: 0.2rem;
  }

  .icon-img {
    width: 0.52rem;
    height: 0.52rem;
  }

  .un-login-title {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.32rem;
      height: 0.16rem;
      margin: 0 6px;
    }
    span {
      color: rgba(219, 10, 7, 1);
      font-size: 0.18rem;
      font-weight: 700;
    }
  }

  .login-now {
    display: block;
    width: 2.1rem;
    height: 0.42rem;
    background: linear-gradient(90deg, #f77140 0%, #e1310c 100%);
    border-radius: 0.08rem;
    color: #fff;
    font-size: 0.14rem;
    margin: 0.24rem auto 0.08rem;
  }
}

.header {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 64px;
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  &.no_filter {
    backdrop-filter: none;
  }

  &.header-shadow {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);
    background: url("~@/assets/home/head_bg.png") 100% 100% no-repeat;
  }

  .wraper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 14rem;
    box-sizing: border-box;
    position: relative;
  }

  .main_logo {
    display: flex;
    align-items: center;

    overflow: hidden;
    .logo {
      width: 1.35rem;
      height: 0.45rem;
      background-image: url("~@/assets/home/logo.png");
      background-size: contain;
      background-repeat: no-repeat;
      &.logo_8on {
        width: 1.9rem;
        height: 0.6rem;
        background-image: url("~@/assets/home/login_8on.png");
        background-size: 1.81rem 0.61rem;
      }
      &.logo_sport247 {
        width: 1.38rem;
        height: 0.45rem;
        background-image: url("~@/assets/home/login_sport247.png");
        background-size: 1.38rem 0.45rem;
      }
    }
  }

  .headLink {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 40px;

    //主导航默认样式
    a {
      font-size: 14px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      padding: 0 40px;
      border: 1px solid transparent;
      margin-right: 20px;
      border-radius: 100px;
      font-weight: 700;
      &:hover {
        border: 1px solid #fc3061;
      }
    }

    a.active-select {
      background: linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
    }
  }

  .header-left {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    float: right;
    width: auto;
    height: 100%;
  }

  .header-right {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    float: right;
    width: 4.8rem;
    height: 100%;
  }

  .search_bar_white,
  .search_bar_gray {
    display: flex;
    justify-content: space-between;
    float: left;
    width: 2.2rem;
    height: 0.4rem;
    overflow: hidden;
    background-color: #f2f2f3;
    border-radius: 0.2rem;
    position: relative;
    padding-left: 0.35rem;
    padding-right: 0.1rem;
    margin-top: 0.12rem;
    color: #999999;

    & > input.search-input {
      display: block;
      float: left;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      line-height: 0.4rem;
      background: transparent;
      // padding: 0px 10px;
      outline: none;
      border: none;
      font-size: 0.14rem;
    }

    & > input::placeholder {
      color: #999999;
    }

    .search-input::-webkit-input-placeholder,
    .search-input:-moz-placeholder,
    .search-input::-moz-placeholder,
    .search-input:-ms-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #999999 !important;
    }

    & > img {
      display: block;
      float: left;
      width: 0.2rem;
      cursor: pointer;
      position: absolute;
      z-index: 2;
      left: 0.1rem;
      top: 0.09rem;
    }
  }

  .search_bar_white {
    background-color: rgba(255, 255, 255, 0.08);

    input {
      color: #fff;
    }

    & > input::placeholder {
      color: rgba(255, 255, 255, 0.35);
    }

    .search-input::-webkit-input-placeholder,
    .search-input:-moz-placeholder,
    .search-input::-moz-placeholder,
    .search-input:-ms-input-placeholder {
      /* WebKit, Blink, Edge */
      color: rgba(255, 255, 255, 0.35) !important;
    }
  }

  .controller {
    display: flex;
    align-items: center;
    // margin-left: 16px;
    justify-content: center;
    margin-left: auto;

    & > button {
      min-width: 0.86rem;
      display: flex;
      align-items: center;
      margin-right: 0.06rem;
      font-size: 0.17rem;
      color: #fff;
      background: transparent;
      cursor: pointer;
      width: 0.96rem;
      height: 0.34rem;
      background-image: linear-gradient(
          90deg,
          #58c0ab 0%,
          #379f9f 50%,
          #157e93 100%
        ),
        linear-gradient(#28ba74, #28ba74);
      background-blend-mode: normal, normal;
      border-radius: 0.03rem;
      justify-content: center;

      & > img {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.05rem;
      }
    }

    .message-icon {
      margin-right: 0.1rem;
      position: relative;

      & > span {
        position: absolute;
        right: -0.05rem;
        top: -0.05rem;
        padding: 0 0.05rem;
        height: 0.2rem;
        box-sizing: border-box;
        min-width: 0.2rem;
        line-height: 0.2rem;
        background: red;
        border-radius: 50%;
        font-size: 0.12rem;
        color: #fff;
        text-align: center;
        // transform: scale(0.8);
      }

      .message {
        font-size: 0.24rem;
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .start-btn {
      margin-right: 44px;
    }
    .start-btn,
    .login-btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      float: left;
      width: auto;
      height: 100%;
      cursor: pointer;
      color: #fff;
      position: relative;
      &:hover {
        p {
          color: #fd3061;
        }
      }

      .icon {
        display: block;
        clear: both;
        width: 0.5rem;
        height: 0.25rem;
        overflow: hidden;
        box-sizing: border-box;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      p {
        clear: both;
        width: 100%;
        height: 0.2rem;
        line-height: 0.2rem;
        overflow: hidden;
        font-size: 12px;
        color: #929393;
        text-align: center;
      }

      div {
        position: absolute;
        bottom: -24px;
      }

      .tip-img {
        width: 100%;
        height: 100%;
      }
    }

    .homeheader .start-btn:hover p {
      color: #fff;
    }

    .img-login {
      width: 100%;
    }
    .note {
      position: absolute;
      top: -0.04rem;
      right: -0.02rem;
      padding: 0 0.05rem;
      min-width: 0.1rem;
      height: 0.2rem;
      line-height: 0.2rem;
      text-align: center;
      border-radius: 0.2rem;
      background: #f64d5c;
      color: #ffffff;
      font-size: 0.12rem;
      margin-left: 0.06rem;
    }

    .login,
    .download {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      .own-live {
        font-size: 0.12rem;
        margin-right: 0.1rem;
        cursor: pointer;
        font-weight: 600;
      }

      & > img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.06rem;

        &.avatar {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      & > p {
        font-size: 0.12rem;
        font-weight: 600;
        color: #333;

        &.nickname {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 0.6rem;
        }

        &:nth-child(2) {
          padding-left: 0.06rem;
          padding-right: 0.04rem;
        }

        &:nth-child(3) {
          padding-left: 0.04rem;
          border-left: 0.01rem solid #eee;
        }
      }
    }

    .login {
      width: 0.7rem;
      height: 0.34rem;
      border-radius: 0.03rem;
      background-color: #021e24;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .login p {
      font-size: 0.16rem;
      margin: 0 0.09rem;
      color: #24a39c;
      font-weight: 600;
    }

    .login2 {
      width: 0.44rem;
      height: 0.4rem;
      border-radius: 0.03rem;
      position: relative;
      border-radius: 0.03rem;
      // background-color: #021e24;

      .un-login-content {
        right: -0.85rem !important;
      }

      &:hover {
        .un-login-content {
          display: block;
        }
      }

      & > img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.06rem;
      }

      .avatar {
        width: 0.39rem;
        height: 0.39rem;
        border-radius: 50%;
        object-fit: cover;
      }
      .note {
        position: absolute;
        top: -0.04rem;
        right: -0.02rem;
        padding: 0 0.05rem;
        min-width: 0.1rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 0.2rem;
        background: #f64d5c;
        color: #ffffff;
        font-size: 0.12rem;
        margin-left: 0.06rem;
      }
    }

    .download {
      margin-right: 0.2rem;
      text-decoration: none;
    }
  }
}

.homeheader {
  // background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: overlay;
  // backdrop-filter: blur(3px);
}

.otherheader {
  background-image: none;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #fff;
  border-bottom: 1px solid #dcdcdf;

  .controller {
    .start-btn {
      color: #999;

      &:hover {
        color: #666;
      }
    }

    .login-btn {
      color: #666666;
    }
  }
}

//世界杯头部导航的横条
.world_cup_header {
  background-color: #480433;
  border-bottom: 2px solid #000;

  .link {
    a {
      color: rgba(255, 255, 255, 0.75);

      &:hover,
      &.wc_nav_select {
        color: #fff;
        background-color: #a8032b;
        box-shadow: none;
      }

      &.wc_nav_select {
        font-weight: bold;
      }
    }
  }
}

.livenav {
  position: relative;
  cursor: pointer;
}

.subnav-wrap {
  position: absolute;
  left: 32px;
  top: 35px;
  width: 130px;
  background-color: #fff;
  font-size: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 13px 16px;

  & > a {
    display: inline-block;
    line-height: 30px;
    color: #333;
    font-size: 15px;
    margin: 0 12px;

    &:hover {
      color: $theme-color;
    }
  }
}
.el-dropdown-link {
  color: #fff;
}
</style>
